import React from 'react';
import { detoxification, healthySkin, overallHealth } from 'images';
import scale from 'images/Scale.png';
import styles from './styles.scss';

const SecondAnswer = () => (
  <div className={styles.secondAnswer}>
    <div className={styles.images}>
      <img src={overallHealth} alt="Overall Health" />
      <img src={healthySkin} alt="Healthy Skin" />
    </div>
    <div className={styles.images}>
      <img src={scale} alt="Scale" />
      <img src={detoxification} alt="Detoxification" />
    </div>
  </div>
);

export default SecondAnswer;
